export enum PreviousProviderDocumentKeyKind {
  Procedure = 'procedure',
  Lab = 'lab',
  Imaging = 'imaging',
  Pathology = 'pathology',
  Medication = 'medication',
  Vital = 'vital',
  Problem = 'problem',
  ProviderFacilityNote = 'providerFacilityNote',
  Additional = 'additional',
}
